// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"a4-z","dimensionLabel":"b4-z","styleChooserControlWrapper":"c4-z","styleChooserControl":"d4-z","disabled":"e4-z","giftCard":"f4-z","styleChooserText":"g4-z"};